export const techVideoWatchUrl = new URL(process.env.REACT_APP_TECH_VIDEO_URL);
const embedOrigin = new URL(process.env.REACT_APP_YOUTUBE_EMBED_ORIGIN);
const videoId = techVideoWatchUrl.hostname === "youtu.be"
  ? techVideoWatchUrl.pathname.slice(1)
  : techVideoWatchUrl.searchParams.get("v");

if (
  techVideoWatchUrl.protocol !== "https:" ||
  !["youtu.be", "www.youtube.com", "youtube.com"].includes(techVideoWatchUrl.hostname) ||
  !/^[A-Za-z0-9_-]{11}$/.test(videoId || "") ||
  embedOrigin.protocol !== "https:" ||
  embedOrigin.hostname !== "www.youtube-nocookie.com"
) {
  throw new Error("Invalid YouTube video configuration");
}

export const techVideoEmbedUrl = (lang) => {
  const src = new URL(`/embed/${videoId}`, embedOrigin);
  src.search = new URLSearchParams({
    enablejsapi: "1", origin: window.location.origin, playsinline: "1",
    autoplay: "0", controls: "1", fs: "1", hl: lang, cc_lang_pref: lang, rel: "0",
  }).toString();
  return src.toString();
};